import dayjs from 'dayjs';
import { useCallback } from 'react';
import { useGetLatest } from 'react-table';
import { actions } from './shared';

export function useIsToday(hook: any) {
    hook.stateReducers.push(reducer);
    hook.useInstance.push(useInstance);
}

function reducer(state: any, action: any) {
    switch (action.type) {
        case actions.init:
            let todaysDate = dayjs().startOf('day');
            let currentDate = dayjs().startOf('day');
            return {
                todaysDate,
                currentDate,
                nextMonth: dayjs(currentDate).add(1, 'month'),
                numberOfMonths: 1,
                ...state,
            };
        case actions.nextMonth:
            let cd = state.nextMonth;
            return {
                ...state,
                currentDate: cd,
                nextMonth: dayjs(cd).add(1, 'month'),
            };
        case actions.prevMonth:
            let nxtM = state.currentDate;
            let c = nxtM.subtract(1, 'month');
            return {
                ...state,
                currentDate: c,
                nextMonth: nxtM,
            };

        default:
            return state;
    }
}

function useInstance(instance: any) {
    const { dispatch } = instance;

    const getInstance = useGetLatest(instance);

    const goToNextMonth = useCallback(() => {
        dispatch({ type: actions.nextMonth });
    }, [dispatch]);

    const goToPreviousMonth = useCallback(() => {
        dispatch({ type: actions.prevMonth });
    }, [dispatch]);

    Object.assign(getInstance(), {
        goToNextMonth,
        goToPreviousMonth,
    });
}
